import React, { useRef } from "react";
import Select, { components } from "react-select";
import { useTranslation } from "react-i18next";
const SearchableSelect = ({
  options,
  placeholder,
  handleChange,
  handleSubmit,
  errors,
  name,
  formik,
  defaultValue,
  filter,
  isLoading,
  isDisabled,
  isMulti,
  value = isMulti ? [] : "",
  minWidth,
  withIcon = false,
  ...props
}) => {
  const { t } = useTranslation();
  const ref = useRef();
  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      margin: 0,
      padding: 0,
      fontSize: "0.8rem",
    }),
    option: (provided, state) => ({
      ...provided,
      borderBottom: `1px dotted ${state.isSelected ? "#ffffff90" : "#00000050"}`,
      color: state.isSelected ? "#black" : "black",
      backgroundColor: state.isSelected ? "#dcdcdc" : "#F5F5F5",
      fontSize: "0.8rem",
      "&:hover": {
        filter: "brightness(85%)",
      },
    }),

    control: (styles) => ({
      ...styles,

      minWidth: minWidth ? minWidth : "100%",
      margin: "0.4rem",
      fontSize: "0.8rem",
      backgroundColor: isDisabled ? "#e9ecef" : "#ffffff",
      ...(isDisabled && { opacity: 1 }),
      border: "1px solid #ced4da",
      borderRadius: "2px",
      ...(name === "consultantId" && {
        borderRadius: "0.25rem",
      }),
      "&:hover": {
        boxShadow: "none",
      },
      "&:focus , &:visited, &:focus-within, &:focus-visible,&:active": {
        border: "none",
        outline: "none",
        boxShadow: "0 0 0 0.25rem rgb(13 110 253 / 25%)",
        transition: "boxShadow .15s ease-in-out,box-shadow .15s ease-in-out",
      },
    }),
    placeholder: (styles) => ({
      ...styles,
      ...(isDisabled && { color: "#000000" }),
      ...((name === "consultantId" || name === "gender") && {
        fontSize: "1rem",
        fontWeight: "400",
      }),
    }),
    singleValue: (provided, state) => {
      const transition = "opacity 300ms";

      return {
        ...provided,

        transition,
        ...(isDisabled && { color: "#000000" }),
      };
    },
 

    multiValue: (styles) => {
      const color = "#6200ee40";
      return {
        ...styles,
        backgroundColor: color,
        flex: "1 0 auto",
        justifyContent: "space-between",
      };
    },
    multiValueLabel: (styles) => ({
      ...styles,
      // color: "green",
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: "#e6e6e6",
      ":hover": {
        backgroundColor: "#f8f8f8",
        color: "black",
      },
    }),


    valueContainer: (styles) => ({
      ...styles,
      overflowX: "scroll",
      flexWrap: "unset",
      appearance: "none !important",

      /* width */
      "&::-webkit-scrollbar": {
        height: "3px",
      },

      // /* Track */
      "&::-webkit-scrollbar-track": {
        borderRadius: " 10px",
      },

      // /* Handle */
      "&::-webkit-scrollbar-thumb": {
        background: "#6200ee40",
        borderRadius: "10px",
      },
    }),
  };
  const handleChangeMulti = (selected) => {
    if (selected.length > 0) {
      let values = selected.map((el) => el.value);
      handleChange(name, values);
    } else {
      handleChange(name, []);
    }
  };
  const handleChangeSingle = (selected) => {
    if (selected !== null) {
      const { value, ...rest } = selected;
      handleChange(name, value, rest);
      ref.current.blur();
    } else {
      handleChange(name, "");
      ref.current.blur();
    }
  };
  const handleChangeValue = (selected) => {
    if (Array.isArray(selected) && isMulti) {
      handleChangeMulti(selected);
    } else {
      handleChangeSingle(selected);
    }
  };
  const { Option } = components;
  const IconOption = (props) => {
    return (
      <Option {...props}>
        {withIcon && props.data?.icon && (
          <img src={props.data.icon} style={{ width: 24, marginRight: "8px" }} alt="icon" />
        )}
        {props.data.label}
      </Option>
    );
  };

  return (
    <>
      <Select
        noOptionsMessage={() => t("no-options")}
        ref={ref}
        defaultValue={options?.find((el) => el.value === defaultValue)}
        options={options}
        onChange={handleChangeValue}
        styles={customStyles}
        isLoading={isLoading}
        isDisabled={isDisabled}
        isMulti={isMulti}
        isClearable
        isSearchable
        closeMenuOnSelect={!isMulti}
        placeholder={placeholder || "Select..."}
        components={{ Option: IconOption }}
        value={
          isMulti
            ? options?.filter((opt) => value.includes(opt.value))
            : options?.filter((opt) => opt.value === value)
        }
        {...props}
      />
      {errors && <p style={{ color: "red", fontSize: "12px" }}>{errors}</p>}
    </>
  );
};

export default SearchableSelect;
